<script>
  export let grow = null
</script>

<style lang="scss">
  .wrap {
    max-width: 1040px;
    width: 100%;
    padding: 0px 2rem;
    box-sizing: border-box;
    &.grow {
      flex-grow: 1;
    }
  }
</style>

<div class="wrap" class:grow>
  <slot /> 
</div>